import { deserialize, object, optional, serializable } from 'serializr';
import { JiraSearchIssueFieldModel } from './jira-search-issue-field.model';

export class JiraSearchIssueModel {
  @serializable
  public id: string;
  @serializable
  public key: string;
  @serializable
  public expand: string;
  @serializable
  public self: string;
  @serializable(optional(object(JiraSearchIssueFieldModel)))
  public fields: JiraSearchIssueFieldModel;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(JiraSearchIssueModel, input));
  }
}
